import BigNumber from 'bignumber.js'
import { computeLiquidityProviderFee } from '@/utils/swap/computeLiquidityProviderFee'

export const useLiquidityProviderFee = (amountIn?: BigNumber, hop?: number) => {
  const lpFee = computeLiquidityProviderFee(hop)
  return amountIn?.multipliedBy(lpFee)
}
